/* istanbul ignore file */
export { default as EntrancePracticeExamInstructions } from './EntrancePracticeExamInstructions';
export { default as ErrorPracticeExamInstructions } from './ErrorPracticeExamInstructions';
export { default as SubmittedPracticeExamInstructions } from './SubmittedPracticeExamInstructions';
